import type { CategoryCode } from 'types/Category';

// Vendor categories eligible for review pills ("Wave 1 categories").
export const WAVE_1_CATEGORY_CODES: readonly CategoryCode[] = [
	'REC',
	'WPH',
	'DJS',
	'PLN',
	'BEA',
	'FLO',
	'OPC',
	'BWP',
	'CAT',
	'BAR',
	'VID',
];

export const MIN_REVIEW_PILLS = 3;
